import IconButton from "../../molecules/IconButton/iconButton";
import style from "./sign-in.module.css";
import { useNavigate } from "react-router-dom";
import SignInForm from "../../organisms/sign-in-form/signInForm";
import Page from "../../molecules/page/page";
import { useTranslation } from "react-i18next";
import Navbar from "../landing-page/segments/navbar/navbar";

const SignIn = ({ auth }) => {
    const { t } = useTranslation(["common"]);

    const navigate = useNavigate();

    return (
        <>
            <Navbar />
            <div className={style.signInWrapper}>
                <div className={style.mainWrapper}>
                    <SignInForm auth={auth} nextPageUrl={"/sign-in"} />
                </div>
            </div>
        </>
    );
};

export default SignIn;
